import { GraphItem } from './GraphItem';
import type { LineType, ArrowType } from '@ardoq/api-types';

abstract class GraphEdgeBase extends GraphItem {
  abstract getLineBeginning(): ArrowType;
  abstract getLineEnding(): ArrowType;
  abstract getLine(): LineType;
  abstract source: string;
  abstract target: string;
}
export { GraphEdgeBase };
